import React from 'react'
import { FormattedMessage } from 'react-intl'
import { getUrlFromPath } from 'utilities/url'
import { accentuate } from '../'
import { Section, IconMessage, Heading } from '../s'
import Paragraph from 'components/typography/paragraph'
import Link from 'components/link'
import { OrderedList, ListItem } from 'components/list'
import {
    CheckCircleFilled as Success,
    AlertTriangleFilled as Warning
} from 'components/feather'

const AzureSupportedFeatures = ({ type }) => (
    <Section>
        <Heading>
            <FormattedMessage
                id="integration_heading_supported_features"
                defaultMessage="Supported features" />
        </Heading>
        <OrderedList>
            <ListItem>
                <IconMessage className="success">
                    <Success size={20} />
                    <div>
                        <Paragraph>
                            <strong>
                                <FormattedMessage
                                    id="integration_azure_feature_heading_sync_users"
                                    defaultMessage="Synchronize users between Azure Active Directory and Huma" />
                            </strong>
                            <br />
                            <FormattedMessage
                                id="integration_azure_feature_text_sync_users"
                                defaultMessage="When synchronizing users manually, Huma will compare the users in Azure Active Directory with users in your Huma organization. Decide what to do with non-matching and missing values, as well as with users that don’t exist in both systems." />
                        </Paragraph>
                    </div>
                </IconMessage>
            </ListItem>
            <ListItem>
                <IconMessage className="success">
                    <Success size={20} />
                    <div>
                        <Paragraph>
                            <strong>
                                <FormattedMessage
                                    id="integration_azure_feature_heading_fields_in_sync"
                                    defaultMessage="Keep profiles automatically updated from Huma to Azure Active Directory in real-time" />
                            </strong>
                            <br />
                            <FormattedMessage
                                id="integration_azure_feature_text_fields_in_sync"
                                defaultMessage="Changes made in the supported profile fields (<link>listed below</link>) will be automatically updated in Azure Active Directory."
                                values={{ link: chunks => (
                                    <Link to={getUrlFromPath('path:integrations.integration.details')({ type })}>
                                        {chunks}
                                    </Link>
                                ) }} />
                        </Paragraph>
                        <OrderedList>
                            <ListItem>
                                <IconMessage className="warning">
                                    <Warning size={20} />
                                    <div>
                                        <Paragraph className="compact">
                                            <FormattedMessage
                                                id="integration_azure_feature_text_resync_updates"
                                                defaultMessage="Note that changes made in Azure Active Directory will not be automatically updated in Huma. To do that, you’ll need to manually <accent>synchronize</accent> once again."
                                                values={{ accent: accentuate }} />
                                        </Paragraph>
                                    </div>
                                </IconMessage>
                            </ListItem>
                        </OrderedList>
                    </div>
                </IconMessage>
            </ListItem>
        </OrderedList>
    </Section>
)

export default AzureSupportedFeatures